
import { HttpResponse } from "../auth/AuthInterface";

export const defaultAcceso: VisualizarAccesoResponseProps = { idAcceso: 0, aplicacion: '', idEstatus: 0, estatus: '', imagen: '', referencia: ''  };

export interface VisualizarAccesoProps {
    records:                VisualizarAccesoResponseProps[];
    currentPageIndex:       number;
    pageCount:              number;
    recordsCount:           number;
}

export interface VisualizarAccesoResponseProps {
    idAcceso:       number;
    aplicacion:     string;
    imagen:         string;
    referencia:     string;
    idEstatus:      number;
    estatus:        string;
    fecha?:         Date;
}

export interface GenerarCodigoAccesoParams {  
    nombres:                string;
    apellidos:              string;
    correoElectronico:      string;
    telefono:               string;

    duracion:               number;
    fecha:                  string;
    privilegeGroups:        string[];
}

export interface GenerarCodigoAccesoResponse extends HttpResponse, VisualizarAccesoResponseProps {}

export interface EnviarWhatsAppParams {    
    idAcceso:         number;
}

export interface ObtenerGrupoAccesosResponse extends HttpResponse {
    privilegeGroups: PrivilegeGroup[];
}

export interface PrivilegeGroup {
    privilegeGroupId:   string;
    privilegeGroupName: string;
    description:        string;
    elementList:        ElementList[];
    selected?:          boolean;
}

export interface ElementList {
    element: Element;
}

export interface Element {
    id:       null;
    baseInfo: BaseInfo;
}

export interface BaseInfo {
    elementType: number;
    name:        string;
    areaName:    string;
    areaId:      null;
}

export interface Dispositivo {
    doorIndexCode:   string;
    doorName:        string;
    acsDevIndexCode: string;
    regionIndexCode: string;
    doorNo:          string;
    doorState:       number;
    doorOutState:    number;
}

export interface ObtenerDispositivosResponse extends HttpResponse{
    dispositivos:   Dispositivo[];
}

export interface ControlarDispositivosParams {
    doorName:        string;
    doorIndexCode:   string;
    controlType:     number;
}